import { useFormContext } from 'react-hook-form'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker, FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface SettlementDateFormFieldProps {}

export const SettlementDateFormField: React.FC<SettlementDateFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ settlement_date: string }>()

  return (
    <FormField
      name="settlement_date"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Settlement Date</FormLabel>
              <FormError />
            </div>
            <DatePicker
              selected={field.value ? new Date(field.value) : undefined}
              onSelect={(date) =>
                setValue('settlement_date', date ? toISO8601(date) : '', {
                  shouldValidate: true,
                })
              }
            />
          </FormItem>
        )
      }}
    />
  )
}
